import colors from 'style-utils/colors';
import styled from 'styled-components';

export const StatsSummaryContainer = styled.div`
  margin-top: 8px;
`;

export const StatsItem = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row;
  padding: 20px 0px 10px;
  border-bottom: 1px solid ${colors.mediumGrey};
  color: ${colors.blackTwelve};
  font-size: 16px;
`;

export const StatsLabel = styled.span`
  font-family: var(--secondary-font-family), sans-serif;
  font-weight: 800;
`;
export const StatsValue = styled.span`
  font-weight: 400;
`;
export const LastAccessText = styled.div`
  margin-top: 12px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`;
